import React from 'react';
import { libraryItems } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Library() {
  return <section className="w-full bg-navy px-4 py-14 md:py-20" data-id="element-163" data-mp="23nauzxfsciz2">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="23ouavmxj4s0b">
        <SectionHeading tone="dark" title="Your complete clinical reference library" intro="All six volumes plus five specialized bonuses: educational frameworks, comparison tables, case-based exercises, and practical references you can revisit anytime." data-id="element-165" data-mp="28lufruin7opu" />

        <ul className="mt-10 divide-y divide-white/10 rounded-3xl bg-navy-soft" data-id="element-166" data-mp="2nba5d76fto3y">
          {libraryItems.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex gap-4 p-5 sm:p-6" data-id="element-167" data-mp="2rb0ruyoxli2o">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-teal text-navy-deep" data-id="element-168" data-mp="1bvbpajcue1t8">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-169" data-mp="1fy83zyz9hdrw" />
              </span>
              <div data-id="element-170" data-mp="3lo9h0zct7r98">
                <h3 className="font-display text-xl font-bold uppercase leading-tight text-white" data-id="element-171" data-mp="3lpub6nv7p86k">{title}</h3>
                <p className="mt-1 text-base leading-relaxed text-white/75" data-id="element-172" data-mp="3grj1qe8twzov">{body}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg text-white/85" data-id="element-173" data-mp="3qodwcm1zefxv">
          Move from scattered information toward a more organized clinical reference system.
        </p>

        <CTAButton className="mt-8" tone="dark" label="Get the blueprint + 5 bonuses" subtext="Instant access · $27 USD" data-id="element-174" data-mp="3jfystcld6aa" />
      </div>
    </section>;
}